document.addEventListener("DOMContentLoaded", function() {
  var currentIndex = 0;
  var slides = document.querySelectorAll('.custom-slide');
  var totalSlides = slides.length;

  // Function to show the next slide
  function nextSlide() {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  }

  // Function to update the slider's position
  function updateSlider() {
    var sliderWrapper = document.querySelector('.custom-slider-wrapper');
    sliderWrapper.style.transform = 'translateX(' + (-100 * currentIndex) + '%)';
  }

  // Automatically move to the next slide every 3 seconds
  setInterval(nextSlide, 3000);

  // Optional: You can add manual navigation buttons (if needed)
  // For example, to add next/prev buttons:
  document.querySelector('.next-btn').addEventListener('click', nextSlide);
  // Similarly for a "previous" button if desired
});



document.addEventListener("DOMContentLoaded", function() {
  var currentIndex = 0;
  var slides = document.querySelectorAll('.fldmainbanneropt-slide');
  var totalSlides = slides.length;
  var sliderWrapper = document.querySelector('.fldmainbanneropt-slider-wrapper');

  // Function to show the next slide
  function nextSlide() {
    // If we're at the last slide, we need to reset the position after the transition
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();

    // Reset the slider position after the transition to create a seamless loop
    if (currentIndex === 0) {
      setTimeout(function() {
        sliderWrapper.style.transition = 'none'; // Disable transition to reset the position
        sliderWrapper.style.transform = 'translateX(0%)'; // Jump back to the first slide
        // Re-enable transition after the reset
        setTimeout(function() {
          sliderWrapper.style.transition = 'transform 0.5s ease-in-out'; // Re-enable transition
        }, 20); // Small delay to ensure the transition is re-enabled properly
      }, 500); // This matches the transition duration for smooth reset
    }
  }

  // Function to update the slider's position
  function updateSlider() {
    sliderWrapper.style.transform = 'translateX(' + (-100 * currentIndex) + '%)';
  }

  // Automatically move to the next slide every 3 seconds
  setInterval(nextSlide, 4500);
});




// Function to create snowflakes starts here 

function createSnowflakes() {
    const snowflakesContainer = document.createElement('div');
    snowflakesContainer.classList.add('snowfall');
    document.body.appendChild(snowflakesContainer);

    // Create 50 snowflakes (you can adjust this number)
    for (let i = 0; i < 50; i++) {
        const snowflake = document.createElement('div');
        snowflake.classList.add('snowflake');
        snowflake.textContent = '❄'; // Snowflake character
        snowflake.style.left = Math.random() * 100 + 'vw'; // Random horizontal position
        snowflake.style.animationDuration = (Math.random() * 5 + 5) + 's'; // Random falling speed
        snowflake.style.animationDelay = Math.random() * 10 + 's'; // Random delay before it falls
        snowflakesContainer.appendChild(snowflake);
    }
}

// Run the snowflakes creation on page load
window.onload = function () {
    createSnowflakes();
};


// Function to create snowflakes ends here


// Function to create floting trusting badge starts here

window.addEventListener('scroll', function() {
  var floatingImage = document.querySelector('.floating-image');
  
  if (window.scrollY > 200) {  // Show after 200px scroll
    floatingImage.style.opacity = '1';
  } else {
    floatingImage.style.opacity = '0';
  }
});



// Function to create floting trusting badge ends here



// Function to create banner arrows starts here


let currentSlide = 0;
const slides = document.querySelectorAll('.fldmainbanneropt-slide');
const totalSlides = slides.length;

function moveSlide(direction) {
  currentSlide += direction;

  if (currentSlide < 0) {
    currentSlide = totalSlides - 1; // Loop back to the last slide
  } else if (currentSlide >= totalSlides) {
    currentSlide = 0; // Loop back to the first slide
  }

  const offset = -100 * currentSlide; // Calculate the transform value
  const sliderWrapper = document.querySelector('.fldmainbanneropt-slider-wrapper');
  sliderWrapper.style.transform = `translateX(${offset}%)`;
}


// Function to create banner arrows ends here